import { render, staticRenderFns } from "./PerfilesCargoPagination.vue?vue&type=template&id=5764a5b4&"
import script from "./PerfilesCargoPagination.vue?vue&type=script&lang=js&"
export * from "./PerfilesCargoPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports